import { useMemo } from 'react';
import { useFeatureIsOn } from 'src/common/growthbook';
import { isTaskBreakdownSupported } from 'src/features/room/helpers/is-task-breakdown-supported';
export const useIsTaskBreakdownSupported = (roomCode: string) => {
  const isFeatureOn = useFeatureIsOn('break-down-second-third-rooms');
  return useMemo(() => isFeatureOn && isTaskBreakdownSupported(roomCode), [roomCode, isFeatureOn]);
};